import CloseOutlined from "@mui/icons-material/CloseOutlined";
import {
	MODAL_CLOSE_BUTTON_CLASS,
	MODAL_CLOSE_BUTTON_OVERLAY_CLASS,
	MODAL_CLOSE_ICON_SIZE,
} from "@config/theme/modals";

interface ModalCloseButtonProps {
	onClick: () => void;
	variant?: "default" | "overlay";
	className?: string;
	"aria-label"?: string;
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
	onClick,
	variant = "default",
	className = "",
	"aria-label": ariaLabel = "Close",
}) => {
	const isOverlay = variant === "overlay";

	return (
		<button
			type="button"
			onClick={onClick}
			aria-label={ariaLabel}
			data-testid="modal-close-button"
			className={`${isOverlay ? MODAL_CLOSE_BUTTON_OVERLAY_CLASS : MODAL_CLOSE_BUTTON_CLASS} ${className}`.trim()}>
			<CloseOutlined sx={{ fontSize: MODAL_CLOSE_ICON_SIZE, fontWeight: 600 }} />
		</button>
	);
};

export default ModalCloseButton;
